<template>
  <div class="summary">
    <div v-if="items" class="summary__item">

      <div class="summary__top">
        <div class="summary__value summary__left"
             v-if="items[0].value">{{items[0].value.toString() .replace('.', ',')}}
          <span>&nbsp;{{declineDays(items[0].value || items[0].hired_value)}}</span>
        </div>
        <div style="color: #8F9CAC!important;" v-else class="summary__value summary__left">-</div>

        <div :style="getColor(items[0].delta, false, true)" class="summary__value summary__right">
          {{ formatNum(items[0].delta) }}<span v-if="items[0].delta">%</span>
        </div>
      </div>
      <div class="summary__title">{{items[0]?.title}}</div>
    </div>


    <div v-if="items" class="summary__item">
      <div class="summary__top">
        <div class="summary__value summary__left"
             v-if="items[1].value">{{formatNum(items[1].value)}}
        </div>
        <div style="color: #8F9CAC!important;" v-else class="summary__value summary__left">Скоро</div>

        <div :style="getColor(items[1].delta, false, true)" class="summary__value summary__right">
          {{formatNum(items[1].delta)}}<span v-if="items[1].delta">%</span>
        </div>
      </div>
      <div class="summary__title">{{items[1]?.title}}</div>
    </div>


    <div v-if="items" class="summary__item">
      <div class="summary__top">
        <div class="summary__value summary__left"
             v-if="items[2].value">{{formatNum(items[2].value)}}%
        </div>
        <div style="color: #8F9CAC!important;" v-else class="summary__value summary__left">-</div>

        <div :style="getColor(items[2].delta, false, true)" class="summary__value summary__right">
          {{formatNum(items[2].delta)}}%
        </div>
      </div>
      <div class="summary__title">{{items[2]?.title}}</div>
    </div>


    <div v-if="items" class="summary__item">
      <div class="summary__top">
        <div class="summary__value summary__left" v-if="items[3].hired_quantity">{{items[3].hired_quantity}}
          <div v-if="items[3].left_hiring_plan"
               class="summary__span"
               :style="getColor(items[3].planned_value)"
          >/{{ items[3].left_hiring_plan }}</div>
        </div>
        <div style="color: #8F9CAC!important;" v-else class="summary__value summary__left">-</div>

        <div :style="getColor(items[3].hired_quantity_delta)" class="summary__value summary__right">{{items[3].hired_quantity_delta}}%/
          <div style="color: #8F9CAC">{{formatNum(items[3].left_hiring_plan_delta)}}%</div>
        </div>
      </div>
      <div class="summary__title">{{items[3]?.title}}</div>
    </div>

    <div v-if="!items" class="summary__item" v-for="item in [0,1,2,3]">
      <div class="summary__top">
        <div style="color: #8F9CAC!important;" class="summary__value summary__left">{{item === 1 ? 'Скоро' : 'Нет данных'}}</div>
      </div>
      <div class="summary__title">{{noContentDescription[item]}}</div>
    </div>
  </div>
</template>
<script setup>
import {declineDays, formatNum, getColor} from "@/utils";

const props = defineProps({
  items: [Object, Array],
})

const noContentDescription = [
    'Ср. время закрытия вакансии',
    'Cр. стоимость кандидата',
    'Средняя конверсия',
    'Найм/План'
]

</script>
<style lang="scss">
.summary {
  gap: 20px;
  display: flex;

  &__item {
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    background-color: white;
    padding: 20px 24px;
    width: 265px;
    height: 93px;
  }

  &__top {
    display: flex;
    justify-content: space-between;
  }

  &__value {
    display: flex;
  }
  &__span {
    color: $grey-pressed;
  }

  &__left {
    font-size: 20px;
    font-weight: 600;
  }

  &__right {
    font-size: 16px;
    align-items: center;
  }

  &__title {
    font-size: 14px;
    margin-top: auto;
    font-weight: 400;
    color: $dark-blue;
  }
}
</style>